module.exports = __webpack_public_path__ + "static/media/checkout-instore.4f395819.svg";